import { ICON_TYPES } from '../constants';

export const MailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.529"
      height="14.706"
      viewBox="0 0 23.529 14.706"
    >
      <path
        id="Vector"
        d="M1.957.647a1.725,1.725,0,0,0-.915.265L11.229,9.405a1.188,1.188,0,0,0,1.56,0L22.958.912a1.725,1.725,0,0,0-.915-.265ZM.334,1.787a1.673,1.673,0,0,0-.1.557V13.656a1.666,1.666,0,0,0,.278.919L7.8,8.027Zm23.332,0L16.215,8.018l7.272,6.558a1.666,1.666,0,0,0,.278-.919V2.344A1.674,1.674,0,0,0,23.666,1.787ZM15.336,8.76l-1.811,1.511a2.379,2.379,0,0,1-3.04,0l-1.8-1.5-7.236,6.5a1.744,1.744,0,0,0,.511.079H22.043a1.744,1.744,0,0,0,.511-.079Z"
        transform="translate(-0.235 -0.647)"
      />
    </svg>
  );
};

MailIcon.iconType = ICON_TYPES.MAIL;
